import { useCallback } from 'react';
import { pick } from 'js/utils/ramda.util';
import { jsonToCsv } from 'js/utils/csv.util';
import { useIsMounted } from 'js/hooks/useIsMounted';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as helpers from '../helpers';
import * as actions from '../../../store/actions';
import { useVisualDates } from '../../useVisualDates';
import { EXPORT_PAGE_SIZE } from '../../../constants';
import { useExportSummary } from './useExportSummary';
import { getRequestDates } from '../../../helpers';
import { useGetExportSportsbookHistory } from './useGetExportSportsbookHistory';
import { useDynamicReducerDispatch, useDynamicReducerSelector } from '../../../store';

export const useOnExportClick = () => {
    const isMounted = useIsMounted();
    const translate = useComponentTranslations();
    const dispatch = useDynamicReducerDispatch();
    const { dateRange, playerName } = useExportSummary();
    const getExportTransactions = useGetExportSportsbookHistory();
    const { startTime, endTime } = useVisualDates();
    const {
        period, startDate, endDate
    } = useDynamicReducerSelector(pick([
        'period', 'startDate', 'endDate'
    ]));

    return useCallback((downloadCSV) => {
        let exportError = null;

        dispatch(actions.exportHistory({ exportError, isExportLoading: true }));

        (async () => {
            const { requestStartDate, requestEndDate } = getRequestDates({ period, startDate, endDate });
            try {
                const transactionsData = await helpers.getAllExportTransactions({
                    period,
                    pageSize: EXPORT_PAGE_SIZE,
                    startDate: requestStartDate,
                    endDate: requestEndDate
                });
                const transactions = getExportTransactions(transactionsData);
                const csv = jsonToCsv([dateRange, playerName, transactions]);

                csv && downloadCSV({
                    csv,
                    endDate: endTime,
                    startDate: startTime,
                    fileName: 'sportsbook_gaming_history'
                });
            } catch (error) {
                exportError = translate('error');
            } finally {
                isMounted() && dispatch(actions.exportHistory({ exportError, isExportLoading: false }));
            }
        })();
    }, [
        dispatch, period, startDate, endDate, getExportTransactions,
        playerName, dateRange, endTime, startTime, translate, isMounted
    ]);
};
